import { ReactNode, useRef, useState } from "react";




export function DraggableWrapper({ children, className }: { children: ReactNode | ReactNode[], className?: string }) {

    const wrapperRef = useRef<any>(null);

    const [windowDragLocked, setWindowDragLocked] = useState<boolean>(false);

    const handleWondowMouseMove = (e: any) => {
        if (windowDragLocked) {
            const svgWrapper = wrapperRef.current;
            svgWrapper.scrollLeft = svgWrapper.scrollLeft - e.movementX;
            svgWrapper.scrollTop = svgWrapper.scrollTop - e.movementY;
        }
    }

    return (
        <div
            ref={wrapperRef}
            className={`${className || 'max-w-screen h-auto overflow-auto'} ${windowDragLocked ? 'cursor-grabbing' : 'cursor-grab'}`}
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setWindowDragLocked(true)
            }}
            onMouseUp={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setWindowDragLocked(false)
            }}
            onMouseMove={handleWondowMouseMove}>
            {children}
        </div>
    )


}